import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { Provider } from 'react-redux';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';
import { theme } from '@thesis3/design-system';
import { AuthProvider } from './auth/AuthProvider';
import { store } from './store';
import { Layout } from './components/Layout';
import { Landing } from './pages/Landing';
import { Callback } from './pages/Callback';
import { AdminRoute } from './pages/AdminRoute';
import { TenantAdminRoute } from './pages/TenantAdminRoute';
import { TenantEntry } from './pages/TenantEntry';
import { WorkbenchRoute } from './pages/WorkbenchRoute';

export function App() {
  return (
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <AuthProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/callback" element={<Callback />} />
              {/* Chrome-free: the Platform Admin console owns its own shell. */}
              <Route path="/admin" element={<AdminRoute />} />
              {/* The root is a redirect: underwriters to the workbench,
                  platform admins to the console. No landing page. */}
              <Route path="/" element={<Landing />} />
              <Route element={<Layout />}>
                <Route path="/workbench" element={<WorkbenchRoute />} />
                <Route path="/tenants" element={<TenantAdminRoute />} />
              </Route>
              {/* The client's own address. Records the slug, then continues to the
                  ordinary route — the realm it will eventually select arrives with
                  ADR 0006 step 2. */}
              <Route path="/t/:slug/*" element={<TenantEntry />} />
              {/* Anything else lands on the signpost rather than on nothing. Without
                  this, an unmatched path rendered an EMPTY document — which is exactly
                  what /t/qbelocal did, and it reads as a broken deployment rather than
                  as a wrong address. */}
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </BrowserRouter>
        </AuthProvider>
      </ThemeProvider>
    </Provider>
  );
}
